<template>
  <v-select
    class="dropdown"
    :value="value"
    :options="options"
    @input="value => $emit('input', value)"
    :searchable="false"
    :clearable="false"
    :components="{ OpenIndicator }"
  />
</template>

<script>
import vSelect from 'vue-select'
import OpenDropdownIcon from '@/components/icons/OpenDropdown'
import 'vue-select/dist/vue-select.css'

export default {
  name: 'dropdown',
  components: { vSelect },
  props: {
    value: Object,
    options: Array
  },
  data: () => ({
    OpenIndicator: OpenDropdownIcon
  })
}
</script>

<style lang="scss">
.dropdown {
  height: 30px;
  min-width: 240px;
  color: rgba(69, 61, 76, 0.7);

  .vs__dropdown-toggle {
    height: inherit;
    background: #FFF;
    border: none;
    border-radius: 15px;
    padding: 0 0 0 10px;

    .vs__selected-options {
      padding-right: 8px;

      .vs__selected {
        position: relative;
        margin: 0;
        padding: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
      }

      input {
        border: none;
        margin: 0;
        padding: 0;
      }
    }

    .vs__actions {
      padding: 0;
      margin: 0 10px 0 0;

      .vs__open-indicator {
        transition: transform 0.3s ease;
      }
    }
  }

  &.vs--open .vs__dropdown-toggle {
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
  }

  .vs__dropdown-menu {
    border: none;
    box-shadow: 0 5px 5px 0 rgba(0,0,0,.15);
    min-width: auto;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;

    .vs__dropdown-option--highlight {
      background: #A217AB;
    }

    li {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .vs__fade-enter-active, .vs__fade-leave-active {
    transition: none;
  }
}
</style>
